import { Buffer } from 'buffer';
import { MILLISECONDS_IN_SECOND } from '../constants';

export const parseJwt = (token) => {
  try {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64'));
  } catch (e) {
    return null;
  }
};

export const checkIsTokenExpired = (token) => {
  const decodedJwt = parseJwt(token);
  if (!decodedJwt?.exp) {
    return true;
  }
  return decodedJwt.exp * MILLISECONDS_IN_SECOND <= Date.now();
};
